import { NgModule, ModuleWithProviders, Injector, InjectionToken, Inject, Optional, Self } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SgAuxRouteBridgeHostComponent } from './aux-route-bridge-host/aux-route-bridge-host.component';
import { SgAuxRouteBridgeOutletDirective } from './aux-route-bridge-outlet.directive';
import { SgAuxRouterLinkDirective, SgAuxRouterLinkWithHrefDirective } from './aux-router-link.directive';
import { SgAuxRoute, SgAuxComponentRoute, SgAuxTemplateRoute } from './models';
import { SgAuxRouter } from './aux-router.service';

export const AUX_ROUTES = new InjectionToken<SgAuxRoute<any>[][]>('AUX_ROUTES');

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [
    SgAuxRouteBridgeHostComponent,
    SgAuxRouteBridgeOutletDirective,
    SgAuxRouterLinkDirective,
    SgAuxRouterLinkWithHrefDirective,
  ],
  exports: [
    SgAuxRouteBridgeHostComponent,
    SgAuxRouteBridgeOutletDirective,
    SgAuxRouterLinkDirective,
    SgAuxRouterLinkWithHrefDirective,
  ],
})
export class SgAuxRouteBridgeModule {
  constructor(
    auxRouter: SgAuxRouter,
    injector: Injector,
    @Optional() @Self() @Inject(AUX_ROUTES) routeMatrix?: SgAuxRoute<any>[][]
  ) {
    if (routeMatrix) {
      for (const routes of routeMatrix) {
        for (const route of routes) {
          if ('component' in route) {
            route.injector = injector;
          }
          auxRouter.defineRoute(route);
        }
      }
    }
  }

  static withRoutes(
    componentRoutes: SgAuxComponentRoute<any>[],
    templateRoutes: SgAuxTemplateRoute<any>[] = []
  ): ModuleWithProviders<SgAuxRouteBridgeModule> {
    return {
      ngModule: SgAuxRouteBridgeModule,
      providers: [
        { provide: AUX_ROUTES, multi: true, useValue: componentRoutes },
        { provide: AUX_ROUTES, multi: true, useValue: templateRoutes },
      ],
    };
  }
}
